<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>To my mum, even though she’ll never read my work because “Too much sex and swearing.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?ac1b138e